import { Response_TranslationData } from "@genericComponents/CFW.js";
import { useGenericStore } from "@customHooks/useGenericStore.js";
const useProductLanguageCode =
  await import("@customHooks/useProductLanguageCode.js").then(
    (mod) => mod.useProductLanguageCode,
  );
export const useTranslate = (tranVal) => {
  const { languageCode } = useProductLanguageCode();
  const responseState =
    typeof window === "undefined"
      ? Response_TranslationData
      : `${Response_TranslationData}-${languageCode}`;
  const tranList = useGenericStore(
    responseState,
    typeof window !== "undefined"
      ? window.initScripts[responseState] ||
          window.initScripts[Response_TranslationData]
      : null,
  );
  if (!tranVal || isNaN(tranVal)) {
    return tranVal;
  }
  return tranList[tranVal.toString()] || tranVal.toString();
};
